import { defineMessages } from 'react-intl';

const definedMessages = defineMessages({
  passcode: {
    id: 'app.keypad.passcode',
    description: 'enter your passcode',
    defaultMessage: 'Enter your passcode',
  },
  passcodeHint: {
    id: 'app.keypad.passcodeHint',
    description: 'enter your passcode 1234',
    defaultMessage: "Enter your passcode (hint: it's 1234)",
  },
});

export default definedMessages;



// WEBPACK FOOTER //
// ./src/components/timeclock/keypad/i18n.js